export enum TraceItemDataset {
  LOGS = 'logs',
  SPANS = 'spans',
}